import { useId } from 'react'
import { inputClass } from './ui'

type Props = {
  label: string
  name: string
  value: string
  onChange: (value: string) => void
  type?: string
  error?: string
  autoComplete?: string
  step?: string
  required?: boolean
}

export default function TextField({ label, name, value, onChange, type = 'text', error, autoComplete, step, required }: Props) {
  const instanceId = useId()
  const id = `field-${name}-${instanceId}`

  return (
    <div className="space-y-2">
      <label htmlFor={id} className="block text-sm font-medium text-ink">{label}</label>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        step={step}
        required={required}
        autoComplete={autoComplete}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        onChange={(e) => onChange(e.target.value)}
        className={inputClass}
      />
      {error && <p id={`${id}-error`} className="text-sm leading-relaxed text-alert-ink">{error}</p>}
    </div>
  )
}
